import Component from '../core/Component'

export const STATES = {
    READY: 'is-ready',
    ACTIVE: 'is-active',
    ENTERING: 'is-entering',
    LEAVING: 'is-leaving',
    HIDDEN: 'is-hidden'
}

export default class AnimCard extends Component {
    constructor(element) {
        super(element, {
            'showEndTransition': null,
            'hideEndTransition': null
        })

        this.ref = {
            show: null,
            hide: null,
            showAndHide: null
        }

        if (this.ref.showAndHide) {
            this.ref.show = this.ref.showAndHide
            this.ref.hide = this.ref.showAndHide
        }

        this.showEndElement = this.ref.show || this.element
        this.hideEndElement = this.ref.hide || this.element
    }

    prepare() {
        this.element.classList.add(STATES.READY)
    }

    hide(shouldAnimate = true) {
        this.element.classList.remove(STATES.ACTIVE)
        this.element.classList.remove(STATES.ENTERING)

        if (!shouldAnimate) {
            this.element.classList.remove(STATES.LEAVING)
            this.element.classList.add(STATES.HIDDEN)
            this.element.removeEventListener('transitionend', this.handleHideEnd)
            return
        }

        this.element.removeEventListener('transitionend', this.handleShowEnd)
        this.element.addEventListener('transitionend', this.handleHideEnd)

        this.element.classList.add(STATES.LEAVING)
    }

    show(shouldAnimate = true) {
        this.element.classList.remove(STATES.HIDDEN)
        this.element.classList.remove(STATES.LEAVING)

        if (!shouldAnimate) {
            this.element.classList.remove(STATES.ENTERING)
            this.element.classList.add(STATES.ACTIVE)
            this.element.removeEventListener('transitionend', this.handleShowEnd)
            return
        }

        this.element.removeEventListener('transitionend', this.handleHideEnd)
        this.element.addEventListener('transitionend', this.handleShowEnd)

        this.element.classList.add(STATES.ENTERING)
    }

    handleHideEnd = () => {
        if (event.target === this.hideEndElement) {
            this.element.classList.remove(STATES.LEAVING)
            this.element.classList.add(STATES.HIDDEN)
            this.element.removeEventListener('transitionend', this.handleHideEnd)
        }
    }

    handleShowEnd = event => {
        if (event.target === this.showEndElement) {
            this.element.classList.remove(STATES.ENTERING)
            this.element.classList.add(STATES.ACTIVE)
            this.element.removeEventListener('transitionend', this.handleShowEnd)
        }
    }
}